/**
 * エージェント用 API が返すエラーの一覧。応答の本文はどれも { code, message } である。
 * 画面は code を見て、表示する文言を t() で決める。message は画面に出さない。
 * message は、開発者が API の応答を読んで原因を追うための値で、画面に出すと英語のロケールでも日本語が出てしまう。
 * code は GraphQL の extensions.code にあるもの（UNAUTHENTICATED、BAD_USER_INPUT、FORBIDDEN、INTERNAL_SERVER_ERROR）はそれに揃える。
 * message は汎用の文言にし、断った理由（どのヘッダーがないか、メールアドレス、IP、接続先、storage や runtime の返した文言など）は返さず、BE のログにだけ出す。
 */
export const AGENT_GATEWAY_ERRORS = {
  unauthenticated: { code: 'UNAUTHENTICATED', message: '認証に失敗しました。再度ログインしてください' },
  badRequest: { code: 'BAD_USER_INPUT', message: 'リクエストが正しくありません' },
  // 所属、アカウント、IP 制限を区別して返すと、権限のない人に組織の有無や IP 制限の有無を教えることになるため、同じエラーにする
  forbidden: { code: 'FORBIDDEN', message: 'この組織にアクセスする権限がありません' },
  agentDisabled: { code: 'AGENT_DISABLED', message: 'この組織ではAIエージェント機能を利用できません' },
  sessionNotFound: { code: 'SESSION_NOT_FOUND', message: 'チャットが見つかりません' },
  turnNotFound: { code: 'TURN_NOT_FOUND', message: '指示が見つかりません' },
  // 取り消そうとした添付ファイルがない。置く前に取り消したときや、取り消しを送り直したときにも返るので、画面は取り消し済みとして扱う
  attachmentNotFound: { code: 'ATTACHMENT_NOT_FOUND', message: '添付ファイルが見つかりません' },
  turnAlreadyRunning: {
    code: 'TURN_ALREADY_RUNNING',
    message: 'このチャットでは別の指示を実行中です。終わってからやり直してください',
  },
  // 会話の対象に送った viewId が、組織にないか、アーカイブされているか、利用者が見られない
  viewNotFound: { code: 'VIEW_NOT_FOUND', message: '会話の対象の view が見つかりません' },
  // 会話の対象に送った view が、MCP のツールで読めない種別である
  viewNotSupported: {
    code: 'VIEW_NOT_SUPPORTED',
    message: '会話の対象にできるのは、KPI、ダッシュボード、シートだけです',
  },
  // storage（セッションの記録を管理する Lambda）が、実行時間の上限を超えた。エージェントの runtime の時間切れとは別の code にする
  agentStorageTimeout: {
    code: 'AGENT_STORAGE_TIMEOUT',
    message: '処理がタイムアウトしました。時間をおいてやり直してください',
  },
  agentUnavailable: {
    code: 'AGENT_UNAVAILABLE',
    message: 'エージェント機能に一時的に接続できません。時間をおいてやり直してください',
  },
  internalError: { code: 'INTERNAL_SERVER_ERROR', message: 'エラーが発生しました。時間をおいてやり直してください' },
} as const

export type AgentGatewayError = (typeof AGENT_GATEWAY_ERRORS)[keyof typeof AGENT_GATEWAY_ERRORS]
